"use client";

import { Layout } from 'antd';
import styles from './WhatGet.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const whatGetData = [
  {
    id: 1,
    title: 'title1',
    desc: 'desc1',
  },
  {
    id: 2,
    title: 'title2',
    desc: 'desc2',
  },
  {
    id: 3,
    title: 'title3',
    desc: 'desc3',
  },
];

export const WhatGet = () => {
  const t = useTranslations('aiAgent.whatGet');

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
      </ScrollReveal>
      <ScrollReveal className={styles.root_cards}>
        {whatGetData.map((item) => (
          <section key={item.id} className={styles.root_cards_item}>
            <h3 className={styles.root_cards_item_title}>{t(item.title)}</h3>
            <p className={styles.root_cards_item_desc}>{t(item.desc)}</p>
          </section>
        ))}
      </ScrollReveal>
    </Content>
  );
};
